import React, { useCallback, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchStories, resetStories } from "../../../_actions/storiesActions";
import SuperList from "../../../_components/details/sidebarPanels/mediaPanel/SuperList";
import StoryCard from "../../../_components/home/StoryCard";
import { TAB_CALENDAR_MEDIA } from "../../../_components/details/constants";

const ProjectsList = ({ onItemClick, onItemDrag }) => {
  const dispatch = useDispatch();
  const stories = useSelector((state) => state.stories);

  const handleItemClick = useCallback(
    (data) => {
      onItemClick?.(data);
    },
    [onItemClick]
  );

  const handleItemDrag = useCallback(
    (event, data) => {
      onItemDrag?.(event, data);
    },
    [onItemDrag]
  );

  const handleLoadPage = useCallback(() => {
    dispatch(fetchStories("", "", 1, {}));
  }, [dispatch]);

  const childElements = useMemo(() => {
    return stories.payload.map((itemData) => {
      const itemPayload = {
        ...itemData,
      };

      return (
        <div
          key={itemData.id}
          className="calendar-media-project-item"
          onClick={onItemClick ? () => handleItemClick(itemPayload) : null}
          onDragStart={
            onItemDrag ? (event) => handleItemDrag(event, itemPayload) : null
          }
          draggable={!!onItemDrag}
          data-grid-groupkey={itemData.groupKey}
        >
          <StoryCard
            story={itemPayload}
            tab={TAB_CALENDAR_MEDIA}
            template={itemPayload.template}
            enableCardSelection={false}
            showDownloadOption={true}
            showKebabMenu={false}
            showExtraOptions={false}
          />
        </div>
      );
    });
  }, [
    stories.payload,
    onItemClick,
    onItemDrag,
    handleItemClick,
    handleItemDrag,
  ]);

  useEffect(() => {
    dispatch(resetStories());
  }, []);

  return (
    <>
      <SuperList
        list="sm-post-media-panel projects-gallery"
        loaded={stories.loaded}
        searchPlaceholder={"Search projects"}
        notFound={"There are no projects."}
        errorsView={null}
        hasMore={!!stories.hasMore}
        loadPage={handleLoadPage}
      >
        {childElements}
      </SuperList>
    </>
  );
};

export default ProjectsList;
